"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCssAndCx = void 0;
require("./tools/Object.fromEntries");
const classnames_1 = require("./tools/classnames");
function createCssAndCx(params) {
    const { serializeStyles, insertStyles, getRegisteredStyles, cache } = params;
    const css = (...args) => {
        const serialized = serializeStyles(args, cache.registered);
        insertStyles(cache, serialized, false);
        return `${cache.key}-${serialized.name}`;
    };
    const { cx } = (() => {
        function merge(registered, css, className) {
            const registeredStyles = [];
            const rawClassName = getRegisteredStyles(registered, registeredStyles, className);
            if (registeredStyles.length < 2) {
                return className;
            }
            return rawClassName + css(registeredStyles);
        }
        const cx = (...args) => merge(cache.registered, css, classnames_1.classnames(args));
        return { cx };
    })();
    return { css, cx };
}
exports.createCssAndCx = createCssAndCx;
//# sourceMappingURL=createCssAndCx.js.map